import { Stack } from "@mui/material";
import MentalWellbeingScreen from ".";
import type { MentalWellbeingChartDataPoint } from "../MentalWellbeingChart";

const sampleDepressionData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 2 },
  { date: "02/04", fullDate: "02.04.2025", score: 1 },
  { date: "04/04", fullDate: "04.04.2025", score: 0 },
  { date: "12/05", fullDate: "12.05.2025", score: 0 },
  { date: "20/08", fullDate: "20.08.2025", score: 0, isSelected: true },
];

const sampleAnxietyData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 1 },
  { date: "02/04", fullDate: "02.04.2025", score: 2 },
  { date: "04/04", fullDate: "04.04.2025", score: 0 },
  { date: "12/05", fullDate: "12.05.2025", score: 1 },
  { date: "20/08", fullDate: "20.08.2025", score: 0, isSelected: true },
];

export default function MentalWellbeingScreenExamples() {
  return (
    <Stack gap={4} width="100%">
      <MentalWellbeingScreen
        depressionChartData={sampleDepressionData}
        anxietyChartData={sampleAnxietyData}
        depressionScore={2}
        anxietyScore={1}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
